import { StandardEvents } from '@shopify/events';

/**
 * Minimal custom element wrapping a trigger button and a native <dialog>.
 * Uses showModal()/close() directly, no dependency on the theme's
 * internal component framework - this only needs open/close.
 *
 * Also closes itself once an add-to-cart completes (StandardEvents.
 * cartLinesUpdate), because the theme's cart drawer auto-opens on the
 * same action - without this, two modal <dialog>s end up open at once
 * (this panel + the cart drawer), which looks broken.
 */
class CreatorPanelComponent extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[ref="trigger"]');
    this.dialog = this.querySelector('[ref="dialog"]');
    this.closeButton = this.querySelector('[ref="closeButton"]');

    if (!this.trigger || !this.dialog) return;

    this.trigger.addEventListener('click', () => {
      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      }
    });

    this.closeButton?.addEventListener('click', () => {
      this.dialog.close();
    });

    // Light dismiss: click on the dialog's own backdrop (the ::backdrop
    // area registers as a click on the dialog element itself, not on any
    // of its children).
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) {
        this.dialog.close();
      }
    });

    this.handleCartLinesUpdate = this.handleCartLinesUpdate.bind(this);
    document.addEventListener(StandardEvents.cartLinesUpdate, this.handleCartLinesUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.handleCartLinesUpdate);
  }

  handleCartLinesUpdate(event) {
    if (!this.dialog?.open) return;

    const closeIfStillOpen = () => {
      if (this.dialog?.open) this.dialog.close();
    };

    if (event.promise) {
      event.promise.then(closeIfStillOpen).catch(() => {});
    } else {
      closeIfStillOpen();
    }
  }
}

customElements.define('creator-panel-component', CreatorPanelComponent);
